<template>
    <button
        v-on:click="show()"
        class="reset"
        aria-controls="notifications-bar"
        :aria-expanded="[expanded ? 'true' : 'false']"
    >
        <span v-if="label_class" :class="label_class">{{ label }}</span>
        <template v-else>{{ label }}</template>
    </button>
</template>
<script>
import { actions, getters, setters } from './store';

export default {
    props: {
        label: {
            type: String,
            default: 'Notifications',
        },
        label_class: {
            type: String,
            default: '',
        },
    },
    mounted: () => {
        actions.init();
    },
    computed: {
        expanded: () => {
            return getters.show();
        },
    },
    methods: {
        show: function () {
            setters.show(true);
        },
    },
};
</script>
